// extracted by mini-css-extract-plugin
export default {"dropmenu":"DropMenu_dropmenu__H8RJ5"};